<script setup lang="ts">
import type { Message } from '../types';
import MessageComponent from './chatComponents/message.vue';
import ChartComponent from './chatComponents/chart.vue';

defineProps<{
  messages: Message[];
  thinking: boolean;
}>();
</script>
<template>
  <div class="w-full h-full space-y-4 p-4 py-8 overflow-y-auto">
    <div
      v-for="(message, index) in messages"
      :key="index"
      class="flex"
      :class="[message.role === 'user' ? 'justify-end' : 'justify-start']"
    >
      <message-component v-if="message.content.type === 'message'" :message="message.content" :role="message.role" class="max-w-[80%]" />
      <chart-component v-if="message.content.type === 'chart'" :message="message.content" :role="message.role" class="max-w-[80%]" />
    </div>
  </div>
</template>
